/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Default_Set_NameInputs */

const en_tags_manager_default_set_name = /** @type {(inputs: Tags_Manager_Default_Set_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const fr_tags_manager_default_set_name = /** @type {(inputs: Tags_Manager_Default_Set_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans titre`)
};

const de_tags_manager_default_set_name = /** @type {(inputs: Tags_Manager_Default_Set_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Titel`)
};

const it_tags_manager_default_set_name = /** @type {(inputs: Tags_Manager_Default_Set_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza titolo`)
};

const ru_tags_manager_default_set_name = /** @type {(inputs: Tags_Manager_Default_Set_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без названия`)
};

const es_tags_manager_default_set_name = /** @type {(inputs: Tags_Manager_Default_Set_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intitulado`)
};

const zh_cn2_tags_manager_default_set_name = /** @type {(inputs: Tags_Manager_Default_Set_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无题`)
};

const ja_tags_manager_default_set_name = /** @type {(inputs: Tags_Manager_Default_Set_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無題`)
};

const hi_tags_manager_default_set_name = /** @type {(inputs: Tags_Manager_Default_Set_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षकहीन`)
};

const pt_pt2_tags_manager_default_set_name = /** @type {(inputs: Tags_Manager_Default_Set_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem título`)
};

/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Tags_Manager_Default_Set_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_default_set_name = /** @type {((inputs?: Tags_Manager_Default_Set_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Default_Set_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_default_set_name(inputs)
	if (locale === "de") return de_tags_manager_default_set_name(inputs)
	if (locale === "it") return it_tags_manager_default_set_name(inputs)
	if (locale === "ru") return ru_tags_manager_default_set_name(inputs)
	if (locale === "es") return es_tags_manager_default_set_name(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_default_set_name(inputs)
	if (locale === "ja") return ja_tags_manager_default_set_name(inputs)
	if (locale === "hi") return hi_tags_manager_default_set_name(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_default_set_name(inputs)
	return en_tags_manager_default_set_name(inputs)
});